import { render, staticRenderFns } from "./MenuSinistra.vue?vue&type=template&id=32004e30&scoped=true&"
import script from "./MenuSinistra.vue?vue&type=script&lang=js&"
export * from "./MenuSinistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32004e30",
  null
  
)

export default component.exports